import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {actions} from '../../common/state/action';
import {loadScript} from '../function';

const IS_ALREADY_JS_LOADING = {
  moment: false,
  native: false,
};

export default function useLoadBannerSdk(type: 'moment' | 'native') {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!IS_ALREADY_JS_LOADING[type]) {
      IS_ALREADY_JS_LOADING[type] = true;

      loadScript(
        type === 'moment'
          ? 'https://t1.daumcdn.net/kas/static/ba.min.js'
          : 'https://t1.daumcdn.net/kas/static/na.min.js',

        () => {
          dispatch(
            actions.setPropertyValues('isLoadedBannerSdk', {[type]: true})
          );
        }
      );
    }
  }, [dispatch, type]);
}
